'use client';

import { AD_EMPTY_EVENT } from '@fe-cnyes/fe-dfp';
import { isServer } from '@fe-common-utils/libs/utils';
import { styled } from '@linaria/react';
import dynamic from 'next/dynamic';
import { Suspense, memo, useCallback, useEffect, useState } from 'react';

const DynamicAdSlot = dynamic(() => import('@fe-news/components/DynamicAd/BaseDynamicAd'), {
  ssr: false
});

type KeywordAdTextProps = {
  profile: AD.Profile;
};

const AdContainer = styled.div`
  padding: 0 16px;
  min-height: 62px;
`;

const KeywordAdText = ({ profile }: KeywordAdTextProps) => {
  const [showAd, setShowAd] = useState(profile && true);

  const handleAdLoadedIsEmpty = useCallback(
    (adRenderEndEvent: Event) => {
      if (profile && (adRenderEndEvent as CustomEvent).detail === `div-gpt-ad-${profile.name}`) {
        setShowAd(false);
      }
    },
    [profile]
  );

  /**
   * 監聽指定廣告是否存在
   */
  useEffect(() => {
    if (isServer) return;

    window.addEventListener(AD_EMPTY_EVENT, handleAdLoadedIsEmpty);

    return () => {
      window.removeEventListener(AD_EMPTY_EVENT, handleAdLoadedIsEmpty);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // AD (延伸閱讀下方主動式關鍵字 - 文字廣告)
  // 當該則新聞沒有延伸閱讀時，就不會出現延伸閱讀的文字廣告
  return showAd ? (
    <AdContainer>
      <Suspense>
        <DynamicAdSlot profile={profile} />
      </Suspense>
    </AdContainer>
  ) : null;
};

export default memo(KeywordAdText);
